<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        <!-- MIS XV ESQUINA SUPERIOR IZQUIERDA -->
        <div class="mis-xv-wrapper-fixed">
          <img
            src="@/assets/corona.png"
            alt="Ornamento"
            class="ornamento-img"
          >
          <div
            ref="misXvTopRef"
            class="mis-xv-top glowing"
          >
            MIS XV
          </div>
        </div>

        <!-- Nombre y Fecha -->
        <div
          ref="nombreRef"
          class="centered-text"
        >
          Valerie <br><br>

          <div
            ref="fechaRef"
            class="fecha-evento"
          >
            <span class="fecha-dia"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-mes"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-anio"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    const misXvTopRef = ref(null)

    onMounted(() => {

      ScrollTrigger.refresh()

      gsap.fromTo(
        fotoPortadaRef.value,
        {
          opacity: 0,
          scale: 1.08,
          filter: 'blur(8px)'
        },
        {
          opacity: 1,
          scale: 1,
          filter: 'blur(0px)',
          duration: 1.8,
          ease: 'power4.out',
          immediateRender: false,
          scrollTrigger: {
            trigger: fotoPortadaRef.value,
            start: 'top top',
            once: true
          }
        }
      )

      gsap.fromTo(
        misXvTopRef.value,
        { opacity: 0, y: -30, scale: 0.9 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1.2,
          ease: 'back.out(1.6)',
          delay: 0.4,
          scrollTrigger: {
            trigger: fotoPortadaRef.value,
            start: 'top top',
            once: true
          }
        }
      )

      gsap.fromTo(
        nombreRef.value,
        {
          opacity: 0,
          y: 50,
          scale: 0.95,
          filter: 'blur(12px)'
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          filter: 'blur(0px)',
          duration: 1.6,
          ease: 'power4.out',
          delay: 0.8,
          scrollTrigger: {
            trigger: fotoPortadaRef.value,
            start: 'top top',
            once: true
          }
        }
      )

      gsap.fromTo(
        fechaRef.value.children,
        { opacity: 0, y: 25 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.18,
          ease: 'power3.out',
          delay: 1.4,
          scrollTrigger: {
            trigger: fotoPortadaRef.value,
            start: 'top top',
            once: true
          }
        }
      )
    })

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      misXvTopRef
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* ================= CONTENEDOR FOTO ================= */
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 90vh;
  overflow: hidden;
  margin-top: -65px;
  background-image:
    linear-gradient(to bottom, rgba(255,255,255,0), rgba(0,0,0,0.35)),
    url('@/assets/AP6A1932E.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;

  box-shadow:
    0 -40px 80px rgba(255,255,255,0.2) inset,
    0 20px 40px rgba(0,0,0,0.3);
}

/* ================= OVERLAY ================= */
.overlay {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end; /* 🔑 AHORA ABAJO */

  color: white;
  z-index: 2;
}

/* ================= MIS XV ================= */
.mis-xv-wrapper-fixed {
  position: absolute;
  top: -25px;
  left: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.ornamento-img {
  width: 40px;
  filter: brightness(0) invert(1);
  margin-bottom: 4px;
}

.mis-xv-top {
  font-family: 'file';
  font-size: 20px;
  letter-spacing: 1px;
  color: white;
}

.glowing {
  animation: glow 2.5s ease-in-out infinite alternate;
}

@keyframes glow {
  from { text-shadow: 0 0 6px rgba(255,255,255,0.3); }
  to   { text-shadow: 0 0 16px rgba(255,255,255,0.9); }
}

/* ================= NOMBRE ================= */
.centered-text {
  margin-bottom: 100px; /* 🔥 distancia desde abajo */
  font-size: 45px;
  font-weight: 500;
  text-align: center;
  line-height: 2.1;
  padding: 0 40px;

  font-family: 'british' !important;
  background: rgb(253,253,253);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  white-space: nowrap;
}

/* ================= FECHA ================= */
.fecha-evento {
  font-family: 'Karla', sans-serif;
  color: white;
  font-size: 18px;
  letter-spacing: 3px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}

.fecha-evento span {
  opacity: 0;
  transform: translateY(20px);
}
</style>
